import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { PAID_COLUMN, PAID_VA_COLUMN, SALES_PAID_MODULE } from "../constant/salesReceiptConstant";

const subDomain = window.location.host.split('.')[0];
const paidColumns = (): Column[] => subDomain === 'valeurs-assurances' ? PAID_VA_COLUMN : PAID_COLUMN;

export const setSalesReceiptPaidPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: SALES_PAID_MODULE,
        default_columns: paidColumns(),
        default_order_by: '',
        default_order: 'asc',
    });
